import { AiOutlineWarning } from "react-icons/ai";
import styled from "styled-components";

export const StyledDropzone = styled.div`
  display: inline-flex;
  overflow: hidden;
`;
export const StyledIconWrap = styled.div`
  display: flex;
  flex-shrink: 0;
`;
export const StyledAiOutlineWarning = styled(AiOutlineWarning)`
  margin-top: 0.1rem;
  margin-left: 0.5rem;
`;
